import React from "react";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";
import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

const LIGHT_GREEN_COLOR = "#12ddc5";

const Questions = ({ doc, StartOrderBtn }) => {
  const {
    heading,
    description,
    link_text,
    bg_color = LIGHT_GREEN_COLOR,
    link,
    internal_link_id,
    start_an_order,
  } = doc?.primary || {};
  const sectionStyle = { backgroundColor: bg_color };

  return (
    <div className="py-5 px-4 p-md-5 p-2xl-5 questions-section prismic-slice" style={sectionStyle}>
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <div className="container container-width py-0 py-md-3 py-2xl-3">
        <div className="row align-items-center">
          <div className="col-lg-4 mb-2 mb-lg-0 text-center text-lg-left">
            <span className="px-3 px-2xl-3 d-inline-block position-relative sns-h2 question-heading same-size-title">
              {textResolver(heading)}
            </span>
          </div>
          <div className="col-lg-8 mt-4 mt-lg-0">
            <div className="row">
              <div className="col-lg-8 d-flex align-items-center justify-content-lg-end justify-content-center color-dark-blue question-description-text same-size-title">
                {textResolver(description)}
              </div>
              <div className="col-lg-4 mt-4 mt-lg-0 d-flex align-items-center justify-content-center justify-content-lg-start">
                {start_an_order && StartOrderBtn ? (
                  <StartOrderBtn className="px-5 px-2xl-5 py-3 py-2xl-3 color-dark-blue font-weight-bold text-uppercase ls-1-67 text-nowrap rounded button button-yellow">
                    {textResolver(link_text)}
                  </StartOrderBtn>
                ) : (
                  link?.url && (
                    <PrismicLinkTag
                      urlText={link_text}
                      url={link?.url}
                      target={link?.target}
                      className="px-5 px-2xl-5 py-3 py-2xl-3 color-dark-blue font-weight-bold text-uppercase ls-1-67 text-nowrap rounded button button-yellow"
                    />
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Questions;
